export default {
    roleInfo: ({roleInfo}) => roleInfo,
    userInfo: ({userInfo}) => userInfo,
    user: ({user}) => user,
    permissions: ({permission}) => permission,
};